// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.CreatePasskeyDialog[data-v-cb9d85b6]
	{
		background-color: #FFFFFF;
		box-shadow: rgba(0,0,0,0.7) 2px 9px 20px 7px;
		min-width: 300px;
		max-width: 500px;
		word-break: break-word;
		word-wrap: break-word;
}
.titleBar[data-v-cb9d85b6]
	{
		background-color: #FFFFFF;
		padding: 8px 14px;
		box-sizing: border-box;
}
.title[data-v-cb9d85b6]
	{
		text-align: center;
		color: black;
		font-weight: bold;
		font-size: 16pt;
}
.bodyContent[data-v-cb9d85b6]
	{
}
.keyIconLg[data-v-cb9d85b6]
	{
		width: 64px;
		height: 64px;
		float: left;
		padding: 0px 1em 0.25em 16px;
}
.message[data-v-cb9d85b6]
	{
		margin: 16px;
}
.warningMessage[data-v-cb9d85b6]
	{
		display: flex;
		align-items: center;
		border: 1px dashed #FF0000;
		padding: 2px;
}
.warningMessage svg[data-v-cb9d85b6]
		{
			flex: 0 0 auto;
}
.warningMessage span[data-v-cb9d85b6]
		{
			flex: 1 1 auto;
}
.controls[data-v-cb9d85b6]
	{
		display: flex;
}
.dialogButton[data-v-cb9d85b6]
	{
		display: inline-block;
		cursor: pointer;
		color: black;
		font-weight: bold;
		font-size: 12pt;
		box-sizing: border-box;
		position: relative;
		padding: 12px 5px;
		flex: 1 0 auto;
		text-align: center;
}
.dialogButton[data-v-cb9d85b6]:hover
		{
			background-color: rgba(0,0,0,0.05);
}
.warningIcon[data-v-cb9d85b6]
	{
		width: 36px;
		height: 36px;
		fill: #FF0000;
		float: left;
		margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/controls/CreatePasskeyPopup.vue"],"names":[],"mappings":";AA0EC;;EAEC,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACtB;AAEA;;EAEC,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACvB;AAEA;;EAEC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AAChB;AAEA;;AAEA;AAEA;;EAEC,WAAW;EACX,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC7B;AAEA;;EAEC,YAAY;AACb;AAEA;;EAEC,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;AACb;AAEC;;GAEC,cAAc;AACf;AAEA;;GAEC,cAAc;AACf;AAED;;EAEC,aAAa;AACd;AAEA;;EAEC,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACnB;AAEC;;GAEC,kCAAkC;AACnC;AAED;;EAEC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,iBAAiB;AAClB","sourcesContent":["<template>\r\n\t<div class=\"CreatePasskeyDialog\" role=\"alertdialog\" aria-labelledby=\"createPasskeyTitle\">\r\n\t\t<div class=\"titleBar\">\r\n\t\t\t<div class=\"title\" id=\"createPasskeyTitle\" role=\"alert\">Create Passkey</div>\r\n\t\t</div>\r\n\t\t<div class=\"dialogBody\">\r\n\t\t\t<div class=\"bodyContent\">\r\n\t\t\t\t<img class=\"keyIconLg\" :src=\"appPath + 'Images/key256.png'\" alt=\"\" role=\"presentation\" />\r\n\t\t\t\t<div class=\"message\">\r\n\t\t\t\t\t<p>We are enhancing security by transitioning from traditional passwords to <b>passkeys</b>.</p>\r\n\t\t\t\t\t<p>Based on <a href=\"https://fidoalliance.org/passkeys/\" target=\"_blank\">FIDO standards</a>, passkeys are a replacement for passwords that provide faster, easier, and more secure sign-ins to websites and apps across a user’s devices. Unlike passwords, passkeys are always strong and phishing-resistant.​</p>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"message warningMessage\" v-if=\"!passkeySupported\">\r\n\t\t\t\t\t<vsvg sprite=\"warning\" class=\"warningIcon\" /><span>This web browser or device does not support <b>passkeys</b>.</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"controls\">\r\n\t\t\t\t<div ref=\"btnOK\" role=\"button\" class=\"dialogButton okButton\" tabindex=\"0\" @click=\"Close\" @keydown.space.enter.prevent=\"Close\">\r\n\t\t\t\t\t{{okText}}\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n<script>\r\n\timport { passkey_supportedAsync } from 'appRoot/scripts/Passkeys';\r\n\timport svg1 from 'appRoot/images/sprite/warning.svg';\r\n\r\n\texport default {\r\n\t\tcomponents: {},\r\n\t\tprops:\r\n\t\t{\r\n\t\t},\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t\tappPath: appContext.appPath,\r\n\t\t\t\tallowPasswordAuth: appContext.passwordAuth,\r\n\t\t\t\tpasskeySupported: false\r\n\t\t\t};\r\n\t\t},\r\n\t\tasync created()\r\n\t\t{\r\n\t\t\tthis.passkeySupported = await passkey_supportedAsync();\r\n\t\t},\r\n\t\tmounted()\r\n\t\t{\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t\tokText()\r\n\t\t\t{\r\n\t\t\t\treturn this.passkeySupported ? \"Create Passkey\" : \"OK\";\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tSetFocus()\r\n\t\t\t{\r\n\t\t\t},\r\n\t\t\tDefaultClose()\r\n\t\t\t{\r\n\t\t\t},\r\n\t\t\tClose()\r\n\t\t\t{\r\n\t\t\t\tthis.$emit('close', {});\r\n\t\t\t}\r\n\t\t},\r\n\t\twatch:\r\n\t\t{\r\n\t\t}\r\n\t}\r\n</script>\r\n<style scoped>\r\n\t.CreatePasskeyDialog\r\n\t{\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tbox-shadow: rgba(0,0,0,0.7) 2px 9px 20px 7px;\r\n\t\tmin-width: 300px;\r\n\t\tmax-width: 500px;\r\n\t\tword-break: break-word;\r\n\t\tword-wrap: break-word;\r\n\t}\r\n\r\n\t.titleBar\r\n\t{\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tpadding: 8px 14px;\r\n\t\tbox-sizing: border-box;\r\n\t}\r\n\r\n\t.title\r\n\t{\r\n\t\ttext-align: center;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 16pt;\r\n\t}\r\n\r\n\t.bodyContent\r\n\t{\r\n\t}\r\n\r\n\t.keyIconLg\r\n\t{\r\n\t\twidth: 64px;\r\n\t\theight: 64px;\r\n\t\tfloat: left;\r\n\t\tpadding: 0px 1em 0.25em 16px;\r\n\t}\r\n\r\n\t.message\r\n\t{\r\n\t\tmargin: 16px;\r\n\t}\r\n\r\n\t.warningMessage\r\n\t{\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tborder: 1px dashed #FF0000;\r\n\t\tpadding: 2px;\r\n\t}\r\n\r\n\t\t.warningMessage svg\r\n\t\t{\r\n\t\t\tflex: 0 0 auto;\r\n\t\t}\r\n\r\n\t\t.warningMessage span\r\n\t\t{\r\n\t\t\tflex: 1 1 auto;\r\n\t\t}\r\n\r\n\t.controls\r\n\t{\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t.dialogButton\r\n\t{\r\n\t\tdisplay: inline-block;\r\n\t\tcursor: pointer;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 12pt;\r\n\t\tbox-sizing: border-box;\r\n\t\tposition: relative;\r\n\t\tpadding: 12px 5px;\r\n\t\tflex: 1 0 auto;\r\n\t\ttext-align: center;\r\n\t}\r\n\r\n\t\t.dialogButton:hover\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,0,0.05);\r\n\t\t}\r\n\r\n\t.warningIcon\r\n\t{\r\n\t\twidth: 36px;\r\n\t\theight: 36px;\r\n\t\tfill: #FF0000;\r\n\t\tfloat: left;\r\n\t\tmargin-right: 8px;\r\n\t}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
